import React from 'react';
import Modal from '../modal/modal';
import { CommonButton } from '@Components';
import { BLUE_WARNING_ICON, CLOSE_NEW_ICON, GOOGLE_NEW_LOGO_ICON } from '@Images';
import { API_URL } from '../../utils/config';
import { SIGNIN_URL, HELP_CENTER_PUBLIC_PROFILE_URL } from '../../utils/constants';
import { Card, CloseButton, Description, GoogleButton, Title, WarningImgContainer } from './Styles';
import { VerificationFailureRecoveryPopupProps } from './types';
import { captchaFailureRecoveryPopupConstant } from './constant';
import { isIframeWindow } from '@Utils/library';

const SUPPORT_TICKET_URL = `${SIGNIN_URL}${HELP_CENTER_PUBLIC_PROFILE_URL}`;

const VerificationFailureRecoveryPopup: React.FC<VerificationFailureRecoveryPopupProps> = ({
  open,
  onClose,
  navigate,
  loggingIssueContent
}) => {
  const popupContent = loggingIssueContent?.captchaFailureRecoveryPopup?.value;
  const title = popupContent?.title ?? captchaFailureRecoveryPopupConstant.title;
  const description = popupContent?.description ?? captchaFailureRecoveryPopupConstant.description;
  const googleCta = popupContent?.googleCta ?? captchaFailureRecoveryPopupConstant.googleCta;
  const googleCtaId = popupContent?.googleCtaId ?? captchaFailureRecoveryPopupConstant.googleCtaId;
  const commonCta = popupContent?.commonCta ?? captchaFailureRecoveryPopupConstant.commonCta;
  const commonCtaId = popupContent?.commonCtaId ?? captchaFailureRecoveryPopupConstant.commonCtaId;

  const handleGoogleSignUp = () => {
    const url = `${API_URL}/auth/google`;
    if (isIframeWindow()) {
      window.parent.location.href = url;
    } else {
      window.location.href = url;
    }
  };

  const handleSupportTicket = () => {
    onClose();
    navigate(SUPPORT_TICKET_URL);
  };

  return (
    <Modal isPopup visible={open} className="insta-modal center-modal verification-failure-overlay">
      <Card>
        <CloseButton onClick={onClose} aria-label="Close">
          <img src={CLOSE_NEW_ICON} alt="close" width="20px" height="20px" />
        </CloseButton>
        <WarningImgContainer>
          <img src={BLUE_WARNING_ICON} alt="warning" />
        </WarningImgContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <GoogleButton onClick={handleGoogleSignUp} id={googleCtaId}>
          <img src={GOOGLE_NEW_LOGO_ICON} alt="google" width="20px" height="20px" />
          {googleCta}
        </GoogleButton>
        <CommonButton
          width={324}
          id={commonCtaId}
          text={commonCta}
          type="link"
          onClick={handleSupportTicket}
        />
      </Card>
    </Modal>
  );
};

export default VerificationFailureRecoveryPopup;
